import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Email from "./views/Email";
import Live2fa from "./views/Live2fa";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/email',
            name: 'Email',
            component: Email,
        },
        {
            path: '/2fa',
            name: 'Live2fa',
            component: Live2fa,
        },
        {
            path: '*',
            component: Home,
        }
    ],
    mode: 'history'
})